import { inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from 'environments/environment';
import { filter, first, tap } from 'rxjs';
import { monetateQKey, textScript } from './models/monetate-keys';

@Injectable({
  providedIn: 'root'
})
export class MonetateService {
  private readonly _rendererFactory = inject(RendererFactory2);
  private readonly _router = inject(Router);

  private renderer!: Renderer2;
  private _scriptInjected = false;

  public initialize(): void {
    if (this.checkStarted()) {
      this._router.events
        .pipe(
          filter((event): event is NavigationEnd => event instanceof NavigationEnd),
          first((event) => this.checkEnabledPage(event.urlAfterRedirects)),
          tap(() => this.loadScript())
        )
        .subscribe();
    }
  }

  private checkStarted(): boolean {
    if (environment.configurations.monetateConfig.active && window[monetateQKey] === undefined) {
      return true;
    }
    return false;
  }

  private checkEnabledPage(currentUrl: string): boolean {
    return environment.configurations.monetateConfig.enabledPages.some((page) => currentUrl.includes(page));
  }

  private loadScript(): void {
    if (!this._scriptInjected) {
      this._scriptInjected = true;
      this.renderer = this._rendererFactory.createRenderer(null, null);
      window[monetateQKey] = [];
      this.injectMonetateScript();
    }
  }

  private injectMonetateScript(): void {
    const monetateScript = this.renderer.createElement('script') as HTMLScriptElement;
    monetateScript.type = textScript;
    monetateScript.text = 'var monetateT = new Date().getTime();';

    if (environment.configurations.monetateConfig.async) {
      monetateScript.async = environment.configurations.monetateConfig.async;
      const protocol = document.location.protocol;
      if (protocol === 'http:' || protocol === 'https:') {
        monetateScript.src = protocol + environment.configurations.monetateConfig.urlAsync;
      }
    } else {
      monetateScript.src = environment.configurations.monetateConfig.urlSync;
    }
    this.renderer.insertBefore(document.head, monetateScript, document.head.firstChild);
  }
}
